<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />


    <div>
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Nome</label>
                    <div class="field-label">{{ objView.nmpessoa }}</div>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item-data">
                    <label class="label-caption">Data</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtsolicitacao) }}</div>
                </div>

                <div class="form-item-data">
                    <label class="label-caption">Prazo</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtprazo) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Solicitação</label>
                    <div class="field-label">{{ objView.solicitacao }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Situação</label>
                    <div class="field-label">{{ objView.nmstatus }}</div>
                </div>
            </div>

            
            <div class="row row-space">
                <div class="form-item-char40">
                    <label class="label-caption">Departamento</label>
                    <div class="field-label">{{ objView.nmdepartamento }}</div>
                </div>
                
                <div class="form-item-char30">
                    <label class="label-caption">Data atendimento</label>
                    <div class="field-label">{{ Funcoes.formatDateTimeFromJson(objView.dhatendimento) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Observações</label>
                    <div class="field-label">{{ objView.obatendimento }}</div>
                </div>
            </div>


            <div class="row-start">
                <button class="btn-small" @click="closeForm">Retornar</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import { Funcoes } from '@/funcoes/utils';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close','save']);
const props = defineProps({idView: {type: Number, default: 0}});

const emitSave= ref(false);
const isLoading = ref(false);
const msgAlerta = ref(null);
const objView = ref({});


const closeForm = () => {
    if (emitSave.value){emit('save')}
    emit('close'); 
}


const lerDados = async() => {
    try{
        isLoading.value = true;
        msgAlerta.value=null;
        const req = await Api.genericPost('/listas/gabinete_agenda_req', {idmunicipio: globalStore.idmunicipio, id: props.idView});
        Object.assign(objView.value, req[0]);
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}

onMounted(lerDados);
</script>